<div>
  <ng-template #loadingOrError>
    <div class="mb-3 text-danger" *ngIf="loadingError$ | async; else loading">
      An error occurred when verifying billing details.
    </div>
  </ng-template>
  <button class="btn btn-primary my-1" [disabled]="loading || !fieldsValid || !hasChanged" (click)="verifyBankDetails()">
    Verify bank details
  </button>
  <div *ngIf="!loading">
    <div style="padding-top: 1rem;">
      <div class="row" *ngFor="let detail of billingDetails">
        <div class="col-3">{{ detail.parameterName }}:</div>
        <div class="col-9">{{ detail.value }}</div>
      </div>
    </div>
  </div>
  <div *ngIf="isValidateError" class="validateError">
    <p>We have been unable to verify the bank details provided. Please check and try again.</p>
    <label>
      <button type="button" class="button check-box-design collapsible-checkbox-button"
      [class.active]="boxChecked" (click)="onCheckBox()"></button>
      <div class="check-text">
        I have checked the account details provided are valid and would like to proceed with these details.
      </div>
    </label>
  </div>
  <div class="warning" [hidden]="allowToProceed">
    The bank details entered are not valid. Please check and try again.
  </div>
</div>